module.exports = __webpack_public_path__ + "static/media/h_08.a8a8ba0a.png";